/* DoctorMobileBottomNav — fixed bottom navigation for mobile-only Doctor Portal.
 *
 *  iter397: 4 tabs — Пациенти · Преглед · MD · Инструменти (SOAP премахнат по заявка)
 *  Hidden на desktop (lg:hidden). Пациент-tab е default. MD табът съдържа
 *  Анализи (бивши клинични фенотипи), coverage phenotypes, mind-body, клиничен
 *  анализ, епигенетична карта — пациент-friendly UX.
 */
import React from "react";
import { Users, ClipboardList, Wrench, Stethoscope } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useTheme } from "@/theme/ThemeContext";

const TABS = [
  { key: "patients", icon: Users,         label_bg: "Пациенти",   label_en: "Patients" },
  { key: "detail",   icon: ClipboardList, label_bg: "Преглед",    label_en: "Review" },
  { key: "md",       icon: Stethoscope,   label_bg: "MD",         label_en: "MD" },
  { key: "tools",    icon: Wrench,        label_bg: "Инструменти", label_en: "Tools" },
];

export default function DoctorMobileBottomNav({ active, onChange, badges = {} }) {
  const { language } = useLanguage();
  const { isDark } = useTheme();
  const bg = language === "bg";

  return (
    <nav
      className={`lg:hidden fixed bottom-0 inset-x-0 z-40 flex items-stretch h-16 border-t backdrop-blur-md pb-[env(safe-area-inset-bottom,0px)] ${
        isDark
          ? "bg-[hsl(222,47%,8%)]/95 border-white/5"
          : "bg-white/95 border-gray-200"
      }`}
      data-testid="doctor-mobile-bottom-nav"
    >
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const isActive = active === tab.key;
        const badge = badges[tab.key];
        // MD tab gets emerald accent for clinical-context distinction
        const activeColor = tab.key === "md" ? "text-emerald-500" : "text-violet-500";
        const accentBar = tab.key === "md"
          ? "bg-gradient-to-r from-emerald-500 to-teal-500"
          : "bg-gradient-to-r from-violet-500 to-fuchsia-500";
        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => onChange(tab.key)}
            data-testid={`doctor-mobile-nav-${tab.key}`}
            aria-pressed={isActive}
            className={`flex-1 flex flex-col items-center justify-center gap-0.5 relative transition-colors px-1 ${
              isActive
                ? activeColor
                : (isDark ? "text-gray-500 hover:text-gray-300" : "text-gray-500 hover:text-gray-800")
            }`}
          >
            <div className="relative">
              <Icon className={`w-5 h-5 transition-transform ${isActive ? "scale-110" : ""}`} />
              {!!badge && badge > 0 && (
                <span className="absolute -top-1 -right-1.5 min-w-[14px] h-[14px] rounded-full bg-rose-500 text-white text-[9px] font-bold flex items-center justify-center px-1">
                  {badge > 9 ? "9+" : badge}
                </span>
              )}
            </div>
            <span className={`text-[10px] font-semibold ${isActive ? "" : "opacity-80"}`}>
              {bg ? tab.label_bg : tab.label_en}
            </span>
            {isActive && (
              <span className={`absolute top-0 inset-x-4 h-[2px] rounded-full ${accentBar}`} />
            )}
          </button>
        );
      })}
    </nav>
  );
}
